import { unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["value", "type", "required", "maxlength", "list"];
const _hoisted_2 = ["id"];
const _hoisted_3 = ["value"];
import { computed, ref, toRefs, useSlots } from 'vue';
import { cloneDeep, debounce } from 'lodash';
export default {
  __name: 'AppgSuggestionInput',
  props: {
    valid: {
      type: Boolean,
      default: true
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    modelValue: String,
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    group: {
      type: Boolean,
      description: 'Whether input is an input group (manual override in special cases)'
    },
    alternative: {
      type: Boolean,
      description: 'Whether input is of alternative layout'
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
      default: 'form-control-label'
    },
    inputClasses: {
      type: String,
      description: 'Input css classes'
    },
    inputGroupClasses: {
      type: String,
      description: 'Input group css classes'
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    type: {
      type: String,
      description: 'Input type',
      default: 'text'
    },
    appendIcon: {
      type: String,
      description: 'Append icon (right)'
    },
    prependIcon: {
      type: String,
      description: 'Prepend icon (left)'
    },
    maxLength: {
      type: [String, Number],
      description: 'Limited Max Length',
      default: ''
    },
    isFormGroup: {
      type: Boolean,
      description: 'Whether is form-group className',
      default: true
    },
    isFormInline: {
      type: Boolean,
      description: 'form-inline className'
    },
    inlineHeadText: {
      type: String,
      description: 'inline head text'
    },
    inlineTailText: {
      type: String,
      description: 'inline tail text'
    },
    isInlineBlock: {
      type: Boolean,
      description: 'display inline-block'
    },
    span: {
      type: String,
      description: 'small text',
      default: ''
    },
    resultLabelName: {
      type: String,
      required: true
    },
    resultValueName: {
      type: String,
      required: true
    },
    dataFetchMethod: {
      type: Function,
      required: true
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  setup(__props, {
    emit: __emit
  }) {
    const slots = useSlots();
    const props = __props;
    const emits = __emit;
    const labelText = ref('');
    const focused = ref(false);
    const inputId = ref(Math.ceil(Math.random() * 10000));
    const dataList = ref([]);
    const selectValue = ref(false);
    const listeners = computed(() => {
      return {
        input: updateValue,
        focus: onFocus,
        blur: onBlur
      };
    });
    const hasIcon = computed(() => {
      const {
        append,
        prepend
      } = slots;
      return append !== undefined || prepend !== undefined || props.appendIcon !== undefined || props.prependIcon !== undefined || props.group;
    });
    const {
      valid,
      invalidMessage
    } = toRefs(props);
    const updateValue = ({
      target
    }) => {
      const {
        value
      } = target;
      labelText.value = value;
      if (!value) updateModelValue({
        target: {
          value: ''
        }
      });
      if (!!value) fetchList(value);
    };
    const updateModelValue = ({
      target
    }) => {
      const {
        value
      } = target;
      const result = cloneDeep(dataList.value)?.filter(elem => elem[props.resultLabelName] + '' == value)?.pop() ?? '';
      if (!result) {
        labelText.value = '';
        return;
      }
      labelText.value = result[props.resultLabelName];
      emits('update:modelValue', result);
    };
    const onFocus = evt => {
      focused.value = true;
      emits('focus', evt);
    };
    const onBlur = evt => {
      focused.value = false;
      emits('blur', evt);
    };
    const fetchList = debounce(async searchText => {
      dataList.value = await props.dataFetchMethod(searchText);
    }, 500);
    return (_ctx, _cache) => {
      const _component_appg_input = _resolveComponent("appg-input");
      return _openBlock(), _createBlock(_component_appg_input, {
        group: __props.group,
        alternative: __props.alternative,
        label: __props.label,
        labelClasses: __props.labelClasses,
        inputClasses: __props.inputClasses,
        inputGroupClasses: __props.inputGroupClasses,
        type: __props.type,
        appendIcon: __props.appendIcon,
        prependIcon: __props.prependIcon,
        span: __props.span,
        valid: _unref(valid),
        "in-valid-message": _unref(invalidMessage)
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("input", _mergeProps({
          value: labelText.value,
          type: __props.type
        }, _ctx.$attrs, {
          required: __props.required,
          class: "form-control",
          maxlength: __props.maxLength
        }, _toHandlers(listeners.value, true), {
          list: inputId.value,
          onChange: updateModelValue
        }), null, 16, _hoisted_1)]), _createElementVNode("datalist", {
          id: inputId.value,
          style: {
            "width": "100%"
          }
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
          return _openBlock(), _createElementBlock("option", {
            key: `dataSet_${index}_${item[__props.resultLabelName]}`,
            value: item[__props.resultLabelName]
          }, null, 8, _hoisted_3);
        }), 128))], 8, _hoisted_2)]),
        _: 1
      }, 8, ["group", "alternative", "label", "labelClasses", "inputClasses", "inputGroupClasses", "type", "appendIcon", "prependIcon", "span", "valid", "in-valid-message"]);
    };
  }
};